import React from 'react';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 px-4 md:px-6 ${className}`} data-id="element-197">
      <div className="max-w-3xl mx-auto" data-id="element-198">{children}</div>
    </section>;
}